import { saveAs } from "file-saver";
import dataProvider from "src/dataProvider";
import { adminInstance } from "src/dataProvider/axios";

const fetcher = dataProvider("adminInstance");

export interface IExportFile {
  file: string;
  date: string; // YYYY-MM-DD (IST)
  time: string; // HH:mm (IST)
  generatedAt: string; // "YYYY-MM-DD HH:mm"
  sizeBytes: number;
}

export interface IExportCategoryGroup {
  categoryKey: string;
  categoryLabel: string;
  files: IExportFile[];
}

export interface IExportRunResult {
  slug: string;
  ok: boolean;
  file?: string;
  error?: string;
}

/**
 * Lists the nightly-generated export files, grouped by export category
 * (newest-first within each category) for the Exports page accordion.
 */
export const getReportExports = async () =>
  fetcher.get<{ data: IExportCategoryGroup[] }>(
    `/projects/report-exports/list`
  );

/**
 * Manually triggers the same job the midnight cron runs — regenerates every
 * export on demand. Returns a per-export ok/error summary.
 */
export const runReportExportsNow = async () =>
  fetcher.post<undefined, { data: IExportRunResult[] }>(
    `/projects/report-exports/run`,
    undefined
  );

/**
 * Downloads a single generated export file as its own .xlsx. Mirrors the
 * existing `downloadS3File` blob pattern in utils/helper.ts.
 */
export const downloadReportExport = async (file: string) => {
  const response = await adminInstance.get(
    `v1/projects/report-exports/file/${encodeURIComponent(file)}/download`,
    { responseType: "blob" }
  );
  saveAs(new Blob([response.data]), file);
};
